const styles = theme => ({
  bannerContainer: {
    width: '100%',
    height: '250px',
    borderRadius: '16px',
    border: '1px solid #E0E0E0',
    display: 'flex',
    flexDirection: 'row',
    backgroundImage: `url('/assets/white-label-banner.svg')`,
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    marginTop: '24px',
  },
  bannerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '400px',
    gap: '16px',
    marginLeft: '50px',
  },
  bannerText: {
    color: '#002E47',
    fontWeight: 500,
    fontSize: '18px',
  },
  bannerDescription: {
    color: '#637381',
    fontSize: '14px',
    fontWeight: 400,
  },
  bannerButton: {
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
    border: '1px solid rgba(145, 158, 171, 0.32)',
    width: '100%',
    color: '#002E47',
    '&:hover': {
      backgroundColor: '#D4DADF',
    },
  },
})

export default styles
